import { isValid, parse, parseISO } from 'date-fns';

// Dates typed into the CMS by hand arrive in whatever shape the editor felt like
// using, so we try the formats they realistically reach for, most explicit first.
const CONTENT_DATE_FORMATS = [
    'dd/MM/yyyy',
    'd/M/yyyy',
    'dd-MM-yyyy',
    'd-M-yyyy',
    'dd.MM.yyyy',
    'd.M.yyyy',
    'yyyy/MM/dd',
    'do MMMM yyyy',
    'd MMMM yyyy',
    'do MMM yyyy',
    'd MMM yyyy',
    'do MMMM yy',
    'd MMMM yy',
    'do MMM yy',
    'd MMM yy',
    'MMMM d yyyy',
    'MMM d yyyy',
    'dd/MM/yy',
    'd/M/yy',
];

// A four digit year pattern happily reads "26" as the year 26, so anything
// outside a plausible range means we picked the wrong format, not a real date
const isPlausible = date =>
    isValid(date) && date.getFullYear() >= 1900 && date.getFullYear() <= 2100;

/**
 * Turns a hand-entered date string into a Date, accepting UK day-first formats,
 * written months and ISO. Returns null for anything unreadable so a typo in the
 * CMS is ignored rather than breaking the page it sorts.
 */
export const parseFlexibleDate = value => {
    if (value === null || value === undefined) {
        return null;
    }

    const text = String(value).trim();

    if (!text) {
        return null;
    }

    if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
        const isoDate = parseISO(text);

        if (isPlausible(isoDate)) {
            return isoDate;
        }
    }

    for (const format of CONTENT_DATE_FORMATS) {
        const date = parse(text, format, new Date());

        if (isPlausible(date)) {
            return date;
        }
    }

    return null;
};

/**
 * Comparator that puts the soonest date first. Entries we can't read a date from
 * sit at the bottom rather than the top, so a typo never takes over the page.
 */
export const bySoonestFlexibleDate = (a, b) => {
    const dateA = parseFlexibleDate(a);
    const dateB = parseFlexibleDate(b);

    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;

    return dateA - dateB;
};
